<template>
	<div>
		<div style="display: flex; justify-content: space-between; align-items: center;">
			<v-btn small icon @click="lastExample"><v-icon class="example-toggle-icon">fa-chevron-left</v-icon></v-btn>
			<p style="display: inline;" class="add-event-example-sub-header-light mb-0">Example {{exampleIndex+1}}/{{examples.length}}</p>
			<v-btn small icon @click="nextExample"><v-icon class="example-toggle-icon">fa-chevron-right</v-icon></v-btn>
		</div>
		<v-divider class="mb-3"></v-divider>
		<p class="add-event-example-sub-header-light">Event Name</p>
		<p class="add-event-example-content">{{examples[exampleIndex].title}}</p>
		<p class="add-event-example-sub-header-light">Tagline / Subtitle</p>
		<p class="add-event-example-content">{{examples[exampleIndex].subtitle}}</p>
		<p class="add-event-example-sub-header-light">What to Expect</p>
		<p class="add-event-example-content mb-0" v-for="(line, index) in examples[exampleIndex].description" :key="index">{{line}}</p>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	data() {
		return {
			exampleIndex: 0,
			examples: [
				{
					title: "WRKPRTY @ Sophia's Sanctuary",
					subtitle: 'Cowork with Sophia and friends in her Venice home.',
					description: [
						'Good people, beautiful work environment, a deep focus on flow.',
						'The plan: 9am - Check-in, Setup, & CoffeeTalk!',
						'9:15  - Warm-up (journal entry)',
						'9:30 - Worksprint #1',
						'10am - Group Break (Introductions)',
						'10:15 - Worksprint #2',
						'11am - Group Break (stretch and chat)',
						'11:15 - Worksprint #3',
						'Noon - Lunch & Siesta',
						'12:30 - Worksprint #4',
						'1:30 - Closing Celebration.',
						'Total head’s down time: 3.25 hrs',
						'Total social time: 1.25 hrs',
						'Total duration: 4.5 hours.'
					]
				},
				{
					title: 'WRKPRTY @ The Sumner House',
					subtitle:
						'Playful weekly coworking near Abbot Kinney, Venice Canals and Beach',
					description: [
						'This weekly WRKPRTY @ The Sumner House is a perfect way to make the most of your day!',
						'Our exact structure (work times & break times) vary slightly week-to-week, but generally you can count on our introduction circle taking place after the first work-sprint, around 10am.',
						'The activities we do vary week to week, but often include yoga or outdoor games that take advantage of our beautiful green grassy yard.'
					]
				},
				{
					title: 'WRKPRTY @ Beach House',
					subtitle:
						'First Friday afternoon coworking in the heart of Venice, CA',
					description: [
						'Our plan is to make the most of this Friday afternoon in the heart of Venice!',
						'12:30-1pm - Early check-in, setup, coffee & networking',
						'WORK SESSION',
						'1:45 - Group Break (Outdoor Stretch & Introductions)',
						'WORK SESSION',
						'2:50 - Group Break (Mingle time)',
						'WORK SESSION',
						'3:50 - Group Break (Quick game)',
						'WORK SESSION',
						'5pm - Closing Celebration',
						'Afterward, we encourage everyone to celebrate with us at the monthly First Friday event - just a few blocks away on Abbot Kinney Boulevard!'
					]
				}
			]
		}
	},
	methods: {
		...mapActions(['setModalOpen']),
		lastExample() {
			this.exampleIndex -= 1
			if (this.exampleIndex < 0) {
				this.exampleIndex = this.examples.length - 1
			}
		},
		nextExample() {
			this.exampleIndex += 1
			if (this.exampleIndex >= this.examples.length) {
				this.exampleIndex = 0
			}
		}
	}
}
</script>
